import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { baseURL, SKIP_PLATFORM_HEADER } from '../constant/constant';
import { AuthBaseService } from './auth-base.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private http: HttpClient,
    private authBaseService: AuthBaseService,
  ) {}

  login(loginData: any): Observable<any> {
    return this.http.post(`${baseURL}login`, loginData);
  }

  exchangeCodeForToken(authCode: string): Observable<any> {
    return this.http.get(
      `${baseURL}exchange-code?code=${encodeURIComponent(authCode)}`,
    );
  }

  private logoutObservable: Observable<any> | null = null;

  logout(logout: boolean = true): Observable<any> {
    if (this.logoutObservable) {
      return this.logoutObservable;
    }

    const context: HttpContext = new HttpContext();

    if (!logout) {
      context.set(SKIP_PLATFORM_HEADER, true);
    }

    this.logoutObservable = this.http
      .post(`${baseURL}logout?logout=${logout}`, {}, { withCredentials: true, context })
      .pipe(
        tap(() => this.authBaseService.broadcastLogout()),
        shareReplay(1),
      );

    return this.logoutObservable;
  }

  getAccessToken(): Observable<any> {
    return this.http.get(`${baseURL}token`);
  }
}
